import React, { useState } from 'react';
import { Autocomplete } from '@react-google-maps/api';
import { InputBase, InputLabel, MenuItem, FormControl, Select } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';

const Header = ({ setCoordinates, type, setType }) => {

    const [autocomplete, setAutocomplete] = useState(null);

    var options = {
        types: ['(regions)'],
        componentRestrictions: { country: "us" }
    };

    const onLoad = (autoC) => setAutocomplete(autoC);

    const onPlaceChanged = () => {
        const lat = autocomplete.getPlace().geometry.location.lat();
        const lng = autocomplete.getPlace().geometry.location.lng();

        setCoordinates({ lat, lng });
    }

    function searchMap() {
        $(".pac-container").css("visibility", "visible");
        var firstResult = $(".pac-container .pac-item:first").text();
        var geocoder = new google.maps.Geocoder();
        geocoder.geocode({ "address": firstResult }, function (results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
                //console.log(results);
                var lat = results[0].geometry.location.lat();
                var lng = results[0].geometry.location.lng();
                //placeName = results[0].address_components[0].long_name,
                //latlng = new google.maps.LatLng(lat, lng);
                var latlng = { lat: lat, lng: lng }

                //console.log(results)

                $(".pac-container .pac-item:first").addClass("pac-selected");
                $(".pac-container").css("display", "none");
                $("#searchTextField").val(firstResult);
                $(".pac-container").css("visibility", "hidden");

                setCoordinates(latlng);
            }
        });
    }

    return (
        <div className="bauer-distributor-header">
            <div className="bauer-distributor-header-container">
                <h3>{`${Drupal.t('Search Distributor')}`}</h3>
                <FormControl className="distributor-finder-category-filter">
                    <InputLabel>{`${Drupal.t('Type')}`}</InputLabel>
                    <Select value={type} onChange={(e) => setType(e.target.value)}>
                        <MenuItem value="breathing-air">{`${Drupal.t('Breathing Air')}`}</MenuItem>
                        {/*<MenuItem value="industrial-air">Industrial Air</MenuItem>*/}
                    </Select>
                </FormControl>
                <div className="bauer-distributor-header-box">
                    <Autocomplete options={options} onLoad={onLoad} onPlaceChanged={onPlaceChanged}>
                        <div className="search-container">
                            <input id="map-search-input" placeholder={Drupal.t('City/State or Zip Code')} className="search-input" />
                        </div>
                    </Autocomplete>
                    <button onClick={() => searchMap()} className="map-search-button">{`${Drupal.t('Search')}`}</button>
                </div>
            </div>
        </div>
    );
}

export default Header;